import { useAttendances } from "./attendances/useAttendances";
import { AttendanceDesktop } from "./attendances/attendanceDesktop";
import { AttendanceMobile } from "./attendances/attendanceMobile";
import ConfirmationDialog from "@/components/confirmationDialog/ConfirmationDialog";
import { translate } from "@/config/translator";

export function Attendances() {
  const {
    onSubmitAttendance,
    onRestoreOriginal,
    restoreOriginalConfirmationOpen,
    setRestoreOriginalConfirmationOpen,
    isTablet,
    submitAttendanceConfirmationOpen,
    setSubmitAttendanceConfirmationOpen,
    lang,
    canRestoreOriginal,
    onRestoreEmployee,
  } = useAttendances();

  return (
    <>
      {isTablet ? (
        <AttendanceDesktop
          openSubmitAttendanceConfirmation={() =>
            setSubmitAttendanceConfirmationOpen(true)
          }
          setRestoreOriginalConfirmationOpen={
            setRestoreOriginalConfirmationOpen
          }
          onRestoreEmployee={onRestoreEmployee}
          canRestoreOriginal={canRestoreOriginal}
        />
      ) : (
        <AttendanceMobile
          setRestoreOriginalConfirmationOpen={
            setRestoreOriginalConfirmationOpen
          }
          openSubmitAttendanceConfirmation={() =>
            setSubmitAttendanceConfirmationOpen(true)
          }
          canRestoreOriginal={canRestoreOriginal}
        />
      )}
      <ConfirmationDialog
        isOpen={submitAttendanceConfirmationOpen}
        onCancel={() => setSubmitAttendanceConfirmationOpen(false)}
        onConfirm={onSubmitAttendance}
        messageString={translate("submitAttendanceConfirmationWarning", lang)}
        titleString={translate("areYouSure", lang)}
      />
      <ConfirmationDialog
        isOpen={restoreOriginalConfirmationOpen}
        onCancel={() => setRestoreOriginalConfirmationOpen(false)}
        onConfirm={onRestoreOriginal}
        titleString={translate("areYouSure", lang)}
        messageString={translate(
          "youAreAboutToRestoreOriginalAttendance",
          lang,
        )}
      />
    </>
  );
}
